import { render, staticRenderFns } from "./KTableInfinite.vue?vue&type=template&id=85db2d92&"
import script from "./KTableInfinite.vue?vue&type=script&lang=js&"
export * from "./KTableInfinite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports